/**
 * File name for a generated document: what it is, the work process and today's date,
 * e.g. "ondersteuningsplan-jw-2283-2026-10-09.docx". `name` is the template's label
 * ("Ondersteuningsplan JW") or a generic kind ("actieplan"); it is written in lower
 * case with hyphens, without accents or characters a file name cannot hold.
 */
export function buildDocumentFilename(name: string, werkprocesNummer?: number | null): string {
  const parts = [toFilePart(name), werkprocesNummer?.toString(), localDate(new Date())];

  return `${parts.filter(Boolean).join('-')}.docx`;
}

function toFilePart(name: string): string {
  const part = name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return part || 'document';
}

// The user's own date: toISOString() would give yesterday's date between midnight
// and the UTC offset.
function localDate(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
